(function() {
  function getUTMParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const utm = {};
    ["utm_source","utm_medium","utm_campaign","utm_term","utm_content"].forEach(key => {
      if (urlParams.has(key)) utm[key] = urlParams.get(key);
    });
    return Object.keys(utm).length ? utm : null;
  }

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days*24*60*60*1000).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; expires=${expires}; SameSite=Lax`;
  }

  const utms = getUTMParams();
  if (utms) {
    setCookie("TWUTM", JSON.stringify(utms), 30); // keep for 30 days
    console.log("[UTM Debug] Stored TWUTM cookie:", utms);
  }
})();
